import { createFileRoute } from '@tanstack/react-router';
import { useLang } from '@/lib/LanguageContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { LegalPageWrap } from '@/components/shared/LegalPageWrap';
import { CarnetContent } from '@/components/sections/carnet-content';

// ═══════════════════════════════════════════════════════════
// /carnet — page SEO du Carnet de ressources AMG Québec d'Océanne.
// Pendant routable du modal Carnet (CarnetContent variant="page").
// Phase 27.81 refonte : passage du blog "articles à venir" vers carnet de
// ressources officielles (AMF, assureurs, soutien post-diagnostic, programmes
// gouv., information, recours). Les articles AMG migrent vers /articles
// dans un sprint futur (route dédiée).
//
// Phase 27.84 — lazy-load CarnetContent. Le Schema.org ItemList + meta
// titre/description/canonical sont SSR-injectés par le Worker
// (src/worker/lib/route-meta.ts + schema-org.ts) ; aucune dépendance au
// chunk lazy pour le crawler.
//
// Phase 27.84b — REVERT lazy-load. Le contenu DOIT être eager pour que les
// crawlers LLM (ChatGPT/Perplexity/Bing/etc.) qui ne rendent pas le JS voient
// le HTML complet. Le modal reste lazy (carnet-modal.tsx) pour la perf UX.
// ═══════════════════════════════════════════════════════════

export function CarnetPage() {
  const { lang } = useLang();
  const text = ta(t.carnet, lang);

  return (
    <LegalPageWrap
      eyebrow={text.eyebrow}
      title={text.title}
      intro={text.intro}
      maxWidth="max-w-4xl"
    >
      <CarnetContent variant="page" />
    </LegalPageWrap>
  );
}

export const Route = createFileRoute('/carnet')({
  component: CarnetPage
});
